export * from "./Ground";
export * from "./Territory";
export * from "./POT";
export * from "./WorldSystem";

export const items = {
  Suelos: {
    path: "/sociales/organizacion-territorial/suelos",
  },
  Territorio: {
    path: "/sociales/organizacion-territorial/territorio",
  },
  POT: {
    path: "/sociales/organizacion-territorial/pot",
  },
  "Sistema mundo": {
    path: "/sociales/organizacion-territorial/sistema-mundo",
  },
};
